module.exports = __webpack_public_path__ + "img/e_3_15_g.f4652ceb.png";